import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled(Modal.Body)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 25px;
  color: #487cf5;
  border-radius: 20px;

  h1 {
    font-size: 20px;
  }
`;

export const AlertContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;

  img {
    width: 25px;
    margin-right: 10px;
  }

  span {
    font-weight: 100;
    color: #808080;
    font-size: 15px;
    

    b {
      font-weight: bold;
      @media (max-width: 767px) {  
        word-break:break-all;
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
`;

export const Button = styled.button`
  width: 47%;
  height: 40px;
  outline: 0;
  border: none;
  background-color: ${({ confirm }) => (confirm ? '#8FC24C' : '#F53832')};
  border: 2px solid ${({ confirm }) => (confirm ? '#8FC24C' : '#F53832')};
  box-shadow: 0px 3px 6px #00000066;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
`;
